import React from 'react'
import { useDatabase } from '../DatabaseContext'
import FillDetailsForm from './FillDetailsForm'
import PostCard from './PostCard'
import PostQuestionsCard from './PostQuestionsCard'
import QuestionCard from './QuestionCard'
import EndMessageCard from './EndMessageCard'

function HomePage() {

  const { appState, curUser, totalStates } = useDatabase()

  return (
    <div className='HomePage'>
      {appState === 0 ?
        <FillDetailsForm /> :
        appState <= curUser.postsOrder.length ?
          <PostCard id={curUser.postsOrder[(appState - 1) % curUser.postsOrder.length]} /> :
          appState <= 2 * curUser.postsOrder.length ?
            <PostQuestionsCard id={curUser.postsOrder[(appState - 1) % curUser.postsOrder.length]} /> :
            appState < totalStates ?
              <QuestionCard id={appState - 2 * curUser.postsOrder.length} /> :
              <EndMessageCard />
      }
    </div>
  )
}

export default HomePage
